// src/components/ProtectedRoute.js
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext'; // useAuth hook'unu import ediyoruz

// DEĞİŞİKLİK: Bileşenin hangi rollere izin vereceğini belirtmek için "allowedRoles" adında bir prop (özellik) almasını sağlıyoruz.
const ProtectedRoute = ({ children, allowedRoles }) => {
  // DEĞİŞİKLİK: Sadece currentUser'ı değil, rol bilgisini içeren "userData"yı da context'ten alıyoruz.
  const { currentUser, userData, loading } = useAuth();

  // Yükleme durumu (loading) aynen kalmalı, bu çok doğru bir yaklaşım.
  // Kimlik doğrulama durumu kontrol edilirken bir yükleme göstergesi gösterir.
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  // 1. KONTROL (Authentication): Kullanıcı giriş yapmış mı?
  // Bu kontrol sende zaten vardı ve doğruydu.
  if (!currentUser) {
    // Giriş yapmamışsa, admin paneline özel giriş sayfasına yönlendir.
    return <Navigate to="/admin/login" />;
  }

  // 2. KONTROL (Authorization): Kullanıcının rolü, izin verilen roller arasında mı?
  // Eğer bu route için bir 'allowedRoles' listesi belirtilmişse bu kontrol çalışır.
  // userData?.role, userData null olsa bile kodun hata vermesini engeller (optional chaining).
// ... inside ProtectedRoute.js
if (allowedRoles && !allowedRoles.includes(userData?.role)) {
    // If the user's role is not in the list of allowed roles,
    // redirect them to the homepage. This is an "Unauthorized Access" situation.
    // UPDATED: Console warning is now in English.
    console.warn(`Access Denied: User with role '${userData?.role}' tried to access a route protected for roles: [${allowedRoles.join(', ')}]`);
    return <Navigate to="/" replace />;
}

  // Eğer kullanıcı hem giriş yapmışsa hem de (gerekliyse) doğru role sahipse,
  // gitmek istediği sayfayı (children) gösteriyoruz.
  return children;
};

export default ProtectedRoute;